import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";

import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";
import "../../Config/loading.css";
import { Link, useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { API_BASE_URL } from "../../Config/Config";
import { Footer } from "../footer/footer";

export default function MostOrdered() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dashboardData, SetDashboardData] = useState([]);
  const [MisUserDetails, SetUserDetails] = useState([]);
  const { setID } = useLabelContext();

  useEffect(() => {
    const MisUserDetailsSession = JSON.parse(
      sessionStorage.getItem("MisUserDetails") ||
        localStorage.getItem("MisUserDetails")
    );
    SetUserDetails(MisUserDetailsSession);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}Dashboard/InventoryDashboard?OrgId=${MisUserDetails.OrgId}&StoreId=0&UserId=${MisUserDetails.UserId}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data.mostOrderedProducts);
        console.log(data);

        if (data && Object.keys(data).length > 0) {
          SetDashboardData(data.mostOrderedProducts);
        } else {
          console.error("Fetched data is not as expected:", data);
          SetDashboardData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (MisUserDetails?.OrgId) {
      fetchData();
    }
  }, [MisUserDetails]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const results = dashboardData.filter(
      (item) =>
        item.ProductName &&
        item.ProductName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setCurrentPage(1);

    return results;
  }, [dashboardData, searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    console.log(dashboardData);
  });

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-2">
            <h4>Most Ordered</h4>
            <h6>Manage Most Ordered</h6>
          </div>
          <div className="search-bar mb-2 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-container mb-0" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-5">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : (
          <div className="row">
            {currentItems &&
              currentItems.map((item, index) => (
                <div
                  key={index}
                  className="col-md-6"
                  style={{ marginTop: "-20px" }}
                >
                  <div
                    className="supplier-card card shadow-sm my-3"
                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title d-flex align-items-center mb-3"
                        style={{ color: "#007bff" }}
                      >
                        {item.StoreName}
                      </h5>
                      <div className="card-details">
                        <div
                          className="row"
                          style={{ color: "#6c757d", marginTop: "10px" }}
                        >
                          <div className="col-7">
                            <span>
                              <i
                                class="fa-solid fa-box"
                                style={{ color: "#007bff" }}
                              ></i>{" "}
                              {item.ProductName}
                            </span>
                          </div>
                          <div className="col-5">
                            <span>
                              <strong>
                                <i
                                  class="fa-solid fa-address-book"
                                  style={{ color: "#007bff" }}
                                ></i>
                              </strong>{" "}
                              {item.ProductCount}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={dashboardData.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>

      <br />
      <br />
      <br />

      <Footer></Footer>
    </Base>
  );
}
